import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourPartnerInTalentAcquisition from "./sections/YourPartnerInTalentAcquisition";
import SolutionsForYourBusinessNeeds from "./sections/SolutionsForYourBusinessNeeds";
import StreamliningRecruitment from "./sections/StreamliningRecruitment";
import SuccessStories from "./sections/SuccessStories";
import OurCommitmentToExcellence from "./sections/OurCommitmentToExcellence";
import WhyChooseActivate from "./sections/WhyChooseActivate";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourPartnerInTalentAcquisition />
      <SolutionsForYourBusinessNeeds />
      <StreamliningRecruitment />
      <SuccessStories />
      <OurCommitmentToExcellence />
      <WhyChooseActivate />
      <GetInTouch />
      <Footer />
    </div>;
}